import React from "react";

const DropdownArrow = () => (
  <svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round"
  >
    <path d="M4 6L8 10L12 6" />
  </svg>
);

export default DropdownArrow;
